import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// "Industry" theme (cms-beta build only). App's own top-level imports —
// including global.css and every page's CSS — are fully evaluated as part
// of `import App from './App'` above, so this import, coming after it,
// always lands later in document order and wins the cascade without
// needing !important.
if (import.meta.env.VITE_THEME === 'industry') {
  void import('./styles/themes/industry-tokens.css');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
